import React from 'react'

import { useInView } from 'react-cool-inview'

import { Badge } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, number, array, object, func,
} from 'prop-types'


const shortTypeLabels = {
  printReady: '3D Print',
  animated: 'Anim',
  pbr: 'PBR',
  rigged: 'Rig',
  lowPoly: 'L-Poly',
}

const formatPrice = (price) => {
  const numPrice = parseFloat(price)
  return numPrice % 1 === 0 ? numPrice.toString() : numPrice.toFixed(2)
}

function ProductGridItem({
  primaryImage,
  title,
  price,
  finalPrice,
  formats,
  types,
  slug,
  id,
  percentage: percentageDiscount = null,
  onVisible = null,
  itemIndex = null,
  itemData = null,
}) {
  const activeTypes = Object.keys(types).filter(type => types[type])

  // Track impression when item comes into view (if callback provided)
  const { observe } = useInView({
    rootMargin: '50px',
    unobserveOnEnter: true,
    onEnter: () => {
      if (onVisible && itemData && typeof itemIndex === 'number') {
        onVisible(itemData, itemIndex)
      }
    },
  })

  return (
    <article className="card-3d-model__article" ref={observe}>
      <div
        className="cgt-model-card__image-container card-3d-model__image-container"
        data-model-id={id}
      >
        <a className="cgt-model-card__link" href={slug}>
          <picture>
            <source
              srcSet={primaryImage}
              type="image/webp"
              loading="lazy"
            />
            <img
              className="cgt-model-card__image"
              src={primaryImage}
              alt={title}
              loading="lazy"
            />
          </picture>
        </a>
      </div>
      <div className="card-3d-model__format-tags card-3d-model__format-tags--visible">
        {formats.map(format => (
          <Badge type="white" hasBorder key={format}>{format}</Badge>
        ))}
      </div>
      <div className="card-3d-model__price card-3d-model__price--visible">
        {!!percentageDiscount && (
          <div
            className={
              'cgt-tag cgt-legacy-back-color-utility-danger-100 '
              + 'cgt-legacy-color-white-100 card-3d-model__discount-tag'
            }
          >
            <span className="cgt-tag__text">-{percentageDiscount}%</span>
          </div>
        )}

        <div className="cgt-tag cgt-legacy-back-color-white-100 cgt-tag--border card-3d-model__price-tag">
          <span className="cgt-tag__text">{price ? `$${formatPrice(finalPrice)}` : 'FREE'}</span>
        </div>

      </div>
      {activeTypes.length > 0 && (
        <div className="card-3d-model__footer card-3d-model__footer--with-title">
          <div className="card-3d-model__type-tags card-3d-model__type-tags--visible">
            {activeTypes.map(type => (
              <Badge type="white" hasBorder key={type}>{shortTypeLabels[type]}</Badge>
            ))}
          </div>
        </div>
      )}
      <div className="card-3d-model__footer-title">
        <h3 className="card-3d-model__footer-title-content">
          <a href={slug}>
            {title}
          </a>
        </h3>
      </div>
    </article>
  )
}

ProductGridItem.propTypes = {
  primaryImage: string.isRequired,
  title: string.isRequired,
  price: number.isRequired,
  finalPrice: number.isRequired,
  formats: array.isRequired,
  types: object.isRequired,
  slug: string.isRequired,
  id: number.isRequired,
  percentage: number,
  onVisible: func,
  itemIndex: number,
  itemData: object,
}

export default ProductGridItem
